<template>
  <div v-if="hasBreadcrumb && breadcrumbData && breadcrumbData.length < 2">
    <h3 class="pageTitle">{{ breadcrumbData[breadcrumbData.length-1].title }}</h3>
  </div>
  <!-- <ul v-if="hasBreadcrumb && breadcrumbData && breadcrumbData.length > 0" class="breadcrumb">
    <li v-for="(item, index) in breadcrumbData" :key="index" class="breadcrumb-item">
      <router-link v-if="item.link" :to="item.url">{{item.title }}</router-link>
      <span v-else>{{ item.title }}</span>
    </li>
  </ul>-->
</template>

<script>
export default {
  data() {
    return {
      breadcrumbData: null
    };
  },

  computed: {
    hasBreadcrumb() {
      return this.$store.state.hasBreadcrumb;
    },

    sidemenuData() {
      return this.$store.state.sidemenuData;
    },

    currentPath() {
      return this.$route.path;
    }
  },

  watch: {
    sidemenuData(val) {
      if (!val.menu) return;
      let arr = [];

      let submenus = val.menu.childEntries.rows;
      let subLink = val.parentType == "submenu";

      for (let i = 0; i < submenus.length; i++) {
        let decide = false;
        if (subLink) {
          decide = submenus[i].id == val.parentId ? true : false;
        } else {
          decide = submenus[i].url == this.currentPath ? true : false;
        }

        if (decide) {
          arr.push({
            url: submenus[i].url,
            title: this.getCaption(submenus[i].contents[0].title),
            link: subLink
          });
        }
      }

      if (subLink) {
        arr.push({
          url: null,
          title: this.getCaption(val.title),
          link: false
        });
      }
      this.breadcrumbData = arr;
    }
  }
};
</script>

<style lang="scss" scoped>
// .breadcrumb {
//   margin: 0 0.8em 15px;
//   font-family: "Roboto Condensed", "Roboto", Arial, sans-serif;
//   font-size: 1.6em;
//   text-transform: uppercase;
//   color: black;
// }
</style>